import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import MyDashboard from './pages/MyDashboard';
import TeamDashboard from './pages/TeamDashboard';
import StatusPage from './pages/StatusPage';
import TasksPage from './pages/TasksPage';
import TaskDetailsPage from './pages/TaskDetailsPage';
import TeamPage from './pages/TeamPage';
import MyStatusPage from './pages/MyStatusPage';
import MyTeamPage from './pages/MyTeamPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import WeeklyReportPage from './pages/WeeklyReportPage';
import InactiveTasksPage from './pages/InactiveTasksPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth/callback/*" element={<AuthCallbackPage />} />
          <Route path="/callback" element={<AuthCallbackPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<MyDashboard />} />
            <Route path="dashboard/team" element={<TeamDashboard />} />
            <Route path="status" element={<StatusPage />} />
            <Route path="inactive-tasks" element={<InactiveTasksPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="tasks/:taskId" element={<TaskDetailsPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="announcements" element={<AnnouncementsPage />} />
            <Route path="reports/weekly" element={<WeeklyReportPage />} />
            <Route path="my-status" element={<MyStatusPage />} />
            <Route path="my-team" element={<MyTeamPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="admin/*" element={<AdminPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
